<template>
  <div>
    <v-layout row wrap>
      <v-btn
        style="min-width: 140px"
        color="primary"
        :outline="selectedMenu !== 'manage'"
        @click="handleSelectMenu('manage')"
        >ตั้งค่าคูปอง</v-btn
      >
      <v-btn
        style="min-width: 140px"
        color="primary"
        :outline="selectedMenu !== 'list'"
        @click="handleSelectMenu('list')"
        >คูปองที่แลก</v-btn
      >
      <v-btn
        style="min-width: 140px"
        color="primary"
        :outline="selectedMenu !== 'receiveList'"
        @click="handleSelectMenu('receiveList')"
        >คูปองที่แจก</v-btn
      >
    </v-layout>
    <ToaMegaPaintEcouponList v-if="selectedMenu == 'list'" />
    <ToaMegaPaintCreateEcoupon v-else-if="selectedMenu == 'manage'" />
    <ToaMegaPaintReceiveEcouponList v-else-if="selectedMenu == 'receiveList'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ToaMegaPaintEcouponList from './ToaMegaPaintEcouponList'
import ToaMegaPaintReceiveEcouponList from './ToaMegaPaintReceiveEcouponList'
import ToaMegaPaintCreateEcoupon from './ToaMegaPaintCreateEcoupon'

export default {
  components: {
    ToaMegaPaintEcouponList,
    ToaMegaPaintCreateEcoupon,
    ToaMegaPaintReceiveEcouponList
  },
  data() {
    return {
      selectedMenu: 'list'
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {},
  methods: {
    handleSelectMenu(menu) {
      this.selectedMenu = menu
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ToaMegaPaintManageEcoupon.vue